import { registerCustomFields } from "@neu/libui";

import { registerFormConfigAdapters } from "./form-config";
import { registerFormEffectHandlers } from "./form-effects";
import { CallNotesField, EsignField } from "./form-fields";
import { registerDomainFormValidators } from "./form-validators";

export function registerAllAdapters(): void {
	registerFormConfigAdapters();
	registerFormEffectHandlers();
	registerDomainFormValidators();
	registerCustomFields([
		{ name: "EsignField", component: EsignField },
		{ name: "CallNotesField", component: CallNotesField },
	]);
}
